var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVeryHappyGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    d: "M24 48C10.745 48 0 37.255 0 24S10.745 0 24 0s24 10.745 24 24-10.745 24-24 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M15 23a3 3 0 1 1 0-6 3 3 0 0 1 0 6zM33 23a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6A822",
    fillRule: "nonzero",
    d: "M23.76 38.88c6.76 0 12.24-6.503 12.24-7.2 0-.697-4.664 3.6-12.24 3.6-7.576 0-12.24-4.703-12.24-3.6 0 1.103 5.48 7.2 12.24 7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M23.76 39.84c6.76 0 15.642-7.14 12.24-8.083-3.402-.943-20.955-.943-24.48 0C7.995 32.7 17 39.84 23.76 39.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.493 7.338l-.097.403a1 1 0 0 1-.522.659c-1.335.674-2.533 1.67-3.593 2.988C8.113 12.84 6.924 15.2 5.71 18.47c.082-2.847.697-5.218 1.846-7.113 1.041-1.716 2.82-3.214 5.335-4.494a.421.421 0 0 1 .6.474z",
    opacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryHappyGrey);
export default __webpack_public_path__ + "static/media/very-happy-grey.3e021c1b.svg";
export { ForwardRef as ReactComponent };